__turbopack_context__.v({
  "backgroundImage": "ABTripDesignerCard-module__QxmeoG__backgroundImage",
  "card": "ABTripDesignerCard-module__QxmeoG__card",
  "content": "ABTripDesignerCard-module__QxmeoG__content",
  "ctaButton": "ABTripDesignerCard-module__QxmeoG__ctaButton",
  "ctaIcon": "ABTripDesignerCard-module__QxmeoG__ctaIcon",
  "title": "ABTripDesignerCard-module__QxmeoG__title",
});
